module.exports = __webpack_public_path__ + "static/media/fly0243.1cd21e30.webp";